import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import moment from "moment";

import { getTeamMembers } from "services/teams_service";
import { getGames } from "services/game_service";
import config from "config.json";

import TeamMemberCard from "./team/teamMemberCard";
import GameCard from "./team/gameCard";

import TopAdd from "components/TopAdd";
import Topnav from "components/Topnav";
import RightAdd from "components/RightAdd";

import { useParams } from "react-router";

import Calendar from "react-calendar";
import { Link } from "react-router-dom";

function App() {
  const { t } = useTranslation();

  const { teamId } = useParams();

  const [staffList, setStaffList] = useState([]);
  const [playerList, setPlayerList] = useState([]);
  const [teamName, setTeamName] = useState(null);

  const [lastGame, setLastGame] = useState(null);
  const [nextGame, setNextGame] = useState(null);
  // get the teams in the backend;

  useEffect(() => {
    async function getTeamsFunc(teamId) {
      try {
        const memList = await getTeamMembers(teamId);
        setPlayerList(memList.filter((el) => el.attributes.role === "Jogador"));
        setStaffList(
          memList.filter(
            (el) =>
              el.attributes.role !== "Jogador" && el.attributes.role !== "Clube"
          )
        );
        console.log("🚀 ~ getTeamsFunc ~ memList:", memList)

        // GET LOGIC
        let teams = JSON.parse(localStorage.getItem("teamIDs"));
        if (!teams || teams.length === 0) return;
        let teamLabel = "";

        let teamInfo = teams.find((el) => el.id + "" === teamId + "");
        if (teamInfo) {
          teamLabel = teamInfo.label;
        }
        setTeamName(teamLabel);

        //TODO NEEDS SORT!
        let lastGame = await getGames(
          {
            date: { $lte: moment().format(config.STRAPI_DATETIME_FORMAT) },
            team: teamId
          },
          ["date:desc"]
        );

        setLastGame(lastGame && lastGame.length > 0 ? lastGame[0] : null);

        //TODO NEEDS SORT!
        let nextGame = await getGames(
          {
            date: { $gte: moment().format(config.STRAPI_DATETIME_FORMAT) },
            team: teamId
          },
          ["date:asc"]
        );

        setNextGame(nextGame && nextGame.length > 0 ? nextGame[0] : null);
      } catch (exception) {
        console.log("exception: ", exception);
      }
    }

    getTeamsFunc(teamId);
  }, []);

  const canEditTeam = () => {
    if (
      localStorage.getItem("role") === "Treinador" ||
      localStorage.getItem("role") === "Clube"
    ) {
      return true;
    }

    return false;
  };

  return (
    <div className="geral">
      <div className="App">
        <Topnav></Topnav>
          <div style={{"display": "flex"}}>
        <section className="section dashboard">
          <div className="conteudo">

          <TopAdd></TopAdd>

            <nav className="breadcrumb" aria-label="breadcrumbs">
              <ul>
                <Link to={"/equipas"}>Plantéis</Link>/ Detalhe
              </ul>
            </nav>
            <div className="columns is-desktop">
              <div className="column is-two-thirds">
                {/* CLUB LOGO AND TEAM*/}
                <div className="flexWrap">
                  <img
                    style={{ width: "126px", height: "95px" }}
                    alt="personImage"
                    src={`${localStorage.getItem("clube_logo")}`}
                  ></img>
                  <h2
                    style={{
                      fontWeight: "900",
                      fontSize: "175%",
                      margin: "auto 0",
                    }}
                  >
                    {teamName}
                  </h2>
                </div>
                <br />
                <br />

                {/* THE PLAYER ITSELF SECTION, IT'S ON TOP*/}
                {localStorage.getItem("role") !== "Clube" && (
                  <div
                    style={{ width: "226px" }}
                    className="team-member-detail"
                  >
                    <TeamMemberCard
                      width={"226px"}
                      height={"220px"}
                      teamId={teamId}
                      name={localStorage.getItem("accountName")}
                      playerNumber={
                        localStorage.getItem("role") === "Jogador"
                          ? localStorage.getItem("shirtNumber")
                          : "" + t(localStorage.getItem("sub_role"))
                      }
                      canEdit={canEditTeam()}
                    ></TeamMemberCard>
                  </div>
                )}
                {canEditTeam() && (
                  <Link
                    className="button is-danger"
                    to={`/equipa/${teamId}/apagar`}
                  >
                    Apagar o plantel
                  </Link>
                )}
                <br />
                <br />
                <h2 className="bold">GUARDA REDES</h2>
                <div className="flexWrap">
                  {playerList
                    .filter(
                      (mem) =>
                        mem?.attributes?.position?.length &&
                        mem.attributes.position[0] === "Guarda-Redes"
                    )
                    .map((el, idx) => (
                      <TeamMemberCard
                        id={el.id}
                        teamId={teamId}
                        name={el.attributes.name}
                        playerNumber={el.attributes.shirt_number}
                        canEdit={canEditTeam()}
                      ></TeamMemberCard>
                    ))}
                </div>

                <br />
                <br />
                <h2 className="bold">DEFESAS</h2>
                <div className="flexWrap">
                  {playerList
                    .filter(
                      (mem) =>
                        mem?.attributes?.position?.length &&
                        (mem.attributes.position[0].startsWith("Defesa") ||
                          mem.attributes.position[0].startsWith("Ala"))
                    )
                    .map((el, idx) => (
                      <TeamMemberCard
                        id={el.id}
                        teamId={teamId}
                        name={el.attributes.name}
                        canEdit={canEditTeam()}
                      ></TeamMemberCard>
                    ))}
                </div>
                <br />
                <br />
                <h2 className="bold">MÉDIOS</h2>
                <div className="flexWrap">
                  {playerList
                    .filter(
                      (mem) =>
                        mem?.attributes?.position?.length &&
                        (mem.attributes.position[0].startsWith("Médio") ||
                          mem.attributes.position[0].startsWith("Extremo"))
                    )
                    .map((el, idx) => (
                      <TeamMemberCard
                        id={el.id}
                        teamId={teamId}
                        name={el.attributes.name}
                        canEdit={canEditTeam()}
                      ></TeamMemberCard>
                    ))}
                </div>
                <br />
                <br />

                <h2 className="bold">AVANÇADOS</h2>
                <div className="flexWrap">
                  {playerList
                    .filter(
                      (mem) =>
                        mem?.attributes?.position?.length &&
                        (mem.attributes.position[0].startsWith("Ponta") ||
                          mem.attributes.position[0].startsWith("Segundo"))
                    )
                    .map((el, idx) => (
                      <TeamMemberCard
                        id={el.id}
                        teamId={teamId}
                        name={el.attributes.name}
                        playerNumber={el.attributes.shirt_number}
                        canEdit={canEditTeam()}
                      ></TeamMemberCard>
                    ))}
                </div>

                {canEditTeam() && (
                  <TeamMemberCard
                    name={"Adicionar jogador"}
                    addPlayerOrStaffLink={`/equipas/${teamId}/novo-jogador`}
                  ></TeamMemberCard>
                )}
                <br />
                <br />
                <h2 className="bold">STAFF</h2>
                <div className="flexWrap">
                  {staffList.map((el, idx) => (
                    <TeamMemberCard
                      id={el.id}
                      teamId={teamId}
                      name={el.attributes.name}
                      playerNumber={
                        el.attributes.sub_role ? t(el.attributes.sub_role) : ""
                      }
                      canEdit={canEditTeam()}
                      isStaff={true}
                    ></TeamMemberCard>
                  ))}
                </div>

                {canEditTeam() && (
                  <TeamMemberCard
                    name={"Adicionar staff"}
                    addPlayerOrStaffLink={`/equipas/${teamId}/novo-staff`}
                  ></TeamMemberCard>
                )}
              </div>
              <div className="column is-one-third-desktop credencial-style">
                <div className="exist" style={{ padding: "12px" }}>
                  {lastGame && (
                    <>
                      <p className="bold">Últimos Resultados:</p>
                      <br></br>
                      <GameCard
                        homeTeamName={
                          lastGame.attributes.location === "home"
                            ? teamName
                            : lastGame.attributes.opponent
                        }
                        homeTeamLogo={
                          lastGame.attributes.location === "home"
                            ? localStorage.getItem("clube_logo")
                            : undefined
                        }
                        awayTeamName={
                          lastGame.attributes.location === "home"
                            ? lastGame.attributes.opponent
                            : teamName
                        }
                        awayTeamLogo={
                          lastGame.attributes.location === "home"
                            ? undefined
                            : localStorage.getItem("clube_logo")
                        }
                        gameDate={lastGame.attributes.date}
                        score={
                          lastGame.attributes.home_team_goals
                            ? lastGame.attributes.home_team_goals +
                              "-" +
                              lastGame.attributes.home_team_goals
                            : undefined
                        }
                      ></GameCard>
                      <br></br>
                    </>
                  )}
                  {nextGame && (
                    <>
                      <p className="bold">Próximos Jogos:</p>
                      <br></br>
                      <GameCard
                        homeTeamName={
                          nextGame.attributes.location === "home"
                            ? teamName
                            : nextGame.attributes.opponent
                        }
                        homeTeamLogo={
                          nextGame.attributes.location === "home"
                            ? localStorage.getItem("clube_logo")
                            : undefined
                        }
                        awayTeamName={
                          nextGame.attributes.location === "home"
                            ? nextGame.attributes.opponent
                            : teamName
                        }
                        awayTeamLogo={
                          nextGame.attributes.location === "home"
                            ? undefined
                            : localStorage.getItem("clube_logo")
                        }
                        gameDate={nextGame.attributes.date}
                        score={
                          nextGame.attributes.home_team_goals
                            ? nextGame.attributes.home_team_goals +
                              "-" +
                              nextGame.attributes.home_team_goals
                            : undefined
                        }
                      ></GameCard>
                      <br></br>
                      <br></br>
                    </>
                  )}

                  <Calendar className="calendar-style fullwidth" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <RightAdd></RightAdd>
         </div>
      </div>
    </div>
  );
}

export default App;
